"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
interface CountdownProps {
  timestamp: number;
}
export default function Countdown(t0) {
  const $ = _c(5);
  const {
    timestamp
  } = t0;
  const [countdown, setCountdown] = useState("");
  let t1;
  let t2;
  if ($[0] !== timestamp) {
    t1 = () => {
      const intervalId = setInterval(() => {
        const now = new Date().getTime();
        const difference = timestamp - now;
        if (difference <= 0) {
          setCountdown("Countdown finished!");
          clearInterval(intervalId);
        } else {
          const days = Math.floor(difference / 86400000);
          const hours = Math.floor(difference % 86400000 / 3600000);
          const minutes = Math.floor(difference % 3600000 / 60000);
          const seconds = Math.floor(difference % 60000 / 1000);
          let countdown_0;
          if (days === 0) {
            if (hours === 0) {
              if (minutes === 0) {
                countdown_0 = `${seconds} seconds`;
              } else {
                countdown_0 = `${minutes} minutes, ${seconds} seconds`;
              }
            } else {
              countdown_0 = `${hours} hours, ${minutes} minutes, ${seconds} seconds`;
            }
          } else {
            countdown_0 = `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
          }
          setCountdown(countdown_0);
        }
      }, 1000);
      return () => clearInterval(intervalId);
    };
    t2 = [timestamp];
    $[0] = timestamp;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== countdown) {
    t3 = <div>{countdown}</div>;
    $[3] = countdown;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}